import { LabClient } from 'models/client-directory';
import { Organization } from 'models/organization';
import { customerSettings } from './customerSettings';
import { CONSTANTS } from 'config/constants';

export const getOverriddenContact = (clientSetting: LabClient, clinic: Organization) => {
    const orderTypeForClinic = customerSettings.getCustomerSetting(
        clinic?.customerSettings || [],
        CONSTANTS.SETTINGS_NAMES.ORDER_VERSION,
    );
    if (orderTypeForClinic === 'Simple' && clinic?.isWhiteLabeled) {
        return clientSetting?.clientContent?.isContactOverridden
            ? clientSetting?.clientContent?.overriddenContact
            : null;
    }
    return null;
};
